import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { LoggerService } from '@app/services/util-services/logger.service';
import { LayoutModel } from '@app/models/server/layout.model';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { SeoUrlSchema } from '@b2b/seo-util-lib';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class DesktopDetailPageDataService {
  constructor(private httpClientService: HttpClientService) {}

  initNewFeatureDetailPage(body: { path?: string; queryParams?: any }) {
    let httpParams: HttpParams = new HttpParams();
    if (body?.queryParams && Object.entries(body?.queryParams)?.length > 0) {
      httpParams = httpParams.appendAll(body?.queryParams);
    }

    return this.httpClientService.get('feature-detail-seo', {
      params: httpParams,
    });
  }

  initFeatureDetailPage(body: {
    path?: string;
    seoUrl?: SeoUrlSchema;
    queryParams?: any;
  }): Observable<LayoutModel> {
    const finalBody: {
      path?: string;
      seoUrl?: SeoUrlSchema;
      queryParams?: any;
    } = {
      path: body.path,
      seoUrl: body?.seoUrl,
      queryParams: body?.queryParams,
    };

    return this.httpClientService.post('feature-detail', finalBody, {});
  }

  updatePopularity() {}
}
